import { EventBusConcrete } from './event/evetnbus-concrete';
import { ITGExecutionTransformation, FeExecutionTransformation } from './transformation/ItgExecutionTransformation';
import { ITG_RENDER_CHANNEL, FE_RENDER_CHANNEL } from './event/channel';
import { FormCustomValidation } from './services/custom_validation';
import { xjsTemplate } from './services/XJStemplate';
/**
 * Export for consumers
 */
export var RsCustomValidation = new FormCustomValidation();
export var RsXJStemplate = new xjsTemplate();
export { ITGExecutionTransformation, FeExecutionTransformation, ITG_RENDER_CHANNEL, FE_RENDER_CHANNEL, };
export var EventBus = EventBusConcrete.getInstance();
///////////////////END EXPORT//////////////////////////
// EventBus.subscribe(ON_INPUT, new InputChangeService());
// export const submitService = new SubmitService();
// EventBus.subscribe(SUBMIT_EVENT, submitService);
// EventBus.publish(SUBMIT_EVENT, {key1: 'Value1', key2: 'Value2'});
//TODO: below code is for local run and test, Remove after work is done
//eventBus.subscribe('notification', emailService);
// eventBus.publish('submit', {key1: 'Value1', key2: 'Value2'});
// eventBus.unsubscribe('submit', submitService);
// eventBus.publish('notification', {key3: 'Value3', key4: 'Value4'});
// import { IHttpClientRequest } from './model/IHttpClientRequest';
// const request: IHttpClientRequest<any> = {
//     url: 'http://api.mocki.io/v1/12b55286',
// };
// const htmlData = execution.transform(request, 'http://localhost:8080/');
// console.log('htmlData', htmlData);
// const request: IHttpClientRequest<any> = Object.assign({
//     url: 'https://jsonplaceholder.typicode.com/posts'
// });
// serverCall.getPosts(request).then(html => {
//     console.log('html', html);
// }).catch(err => {
//     console.log('err', err)
// });
// const request: IHttpClientRequest<any> = {
//     url: 'http://pskb-ms-favorites-dev.g4.app.cloud.comcast.net/user-favorite',
//     headers: {
//       Authorization: 'eyJhbGciOiJSUzI1NiIsImtpZCI6IkpXVFNpZ25pbmdDZXJ0LTIwMjAtTExFIiwicGkuYXRtIjoiNyJ9.eyJzY29wZSI6WyJtYWVzdHJvOmNvbnRlbnQiXSwiY2xpZW50X2lkIjoicmFrYnVzZXIiLCJpc3MiOiJodHRwczovL3dlYnNlYy1xYS5jYWJsZS5jb21jYXN0LmNvbSIsImV4cCI6MTYxMjk4NDQ1MH0.MmoGjfkiKR37Y3lxB5Z3oIEVU5K2mrwCNSG0SM37OlEFzAsBtAZ5Om9KjJjQsH7RHn0zfK89X3d0dasMSnzLX3ajGjMqI2OajJmzhvQB6BuuMijn_0wrwjN2Myp-ODOsmmWAQ2-CLvRgiPKOnaFqcnQ9Od0SlAsD08-fwNFN2xrwFJJjDYoJvCnzS2k9REc-Nzewb7FA-Z2wfPsZ87A4NdQwU3GwLM5IYeFnDk7ldpx1C_GkPBxYpiuDbnZdFFQ5UVUNRGF5Z9LTXjwHGJfiLrmHqylN6FnapRAaOmjwgtXmObTEw4ug5p3jBzy6hvPFDGWkJxJIQW3X8TYja3G6Ag',
//       'Content-type': 'application/json',
//       userDetail: 'eyJ1c2VyaWQiOiJCQ2hva2hhd2FsYSIsInJvbGUiOiJTdXBwb3J0IEFnZW50IiwibG9jYXRpb24iOiIxMjczIiwidXNlclZpZXciOiJSZXNpZGVudGlhbCJ9'
//     }
//   };
//   serverCall.getUserFavorite(request).then(html => {
//     console.log('html', html);
//   }).catch(err => {
//     console.log('err', err)
//   });
//# sourceMappingURL=public_api.js.map